/**
 * @LastEditors lizijian lizijian@linhuiba.com
 * @Date 2023-09-13 19:09
 * @LastEditTime 2023-09-13 19:09
 * @FilePath /console-pc/src/views/recommend/pages/networkPlanApprove/page.config.ts
 * @Description
 */
export default {
  meta: {
    title: '规划管理审批详情',
    parentPath: ['/expandstore/approver'],
    url: '/expandstore/approver',
    breadcrumbs: {
      path: ['/expandstore/approver'],
      name: ['审批工作台'],
    },
  },
};
